import { formatMoney } from '@platform/design-system';
import type { CSSProperties } from 'react';
import { usePageContext } from '../usePageContext.ts';
import type { BrandColors } from './branding.ts';
import styles from './Setup.module.css';

const PREVIEW_AMOUNT = '89.000';

export type LabelPreviewProps = {
  shopName: string;
  currency: string;
  logoUrl: string | null;
  colors: BrandColors;
};

const labelColorsOf = (colors: BrandColors): CSSProperties =>
  ({
    '--label-primary': colors.primary,
    '--label-secondary': colors.secondary,
    '--label-accent': colors.accent,
  }) as CSSProperties;

export const LabelPreview = ({ shopName, currency, logoUrl, colors }: LabelPreviewProps) => {
  const { t, locale } = usePageContext();
  return (
    <figure className={styles['label']} style={labelColorsOf(colors)}>
      <figcaption className={styles['labelCaption']}>{t('setup.previewTitle')}</figcaption>
      <div className={styles['labelHead']}>
        {logoUrl === null ? (
          <span className={styles['labelMark']} aria-hidden="true">
            {shopName.charAt(0)}
          </span>
        ) : (
          <img className={styles['labelLogo']} src={logoUrl} alt={t('setup.logoAlt')} />
        )}
        <strong>{shopName}</strong>
      </div>
      <dl className={styles['labelBody']}>
        <div>
          <dt>{t('setup.previewRecipient')}</dt>
          <dd>{t('setup.previewSample')}</dd>
        </div>
        <div>
          <dt>{t('setup.previewAmount')}</dt>
          <dd className={styles['labelAmount']}>
            {formatMoney({ amount: PREVIEW_AMOUNT, currency }, locale)}
          </dd>
        </div>
      </dl>
      <div className={styles['labelFoot']} aria-hidden="true" />
    </figure>
  );
};
